import React from "react";
import { Box, FormHelperText, Grid, Stack, Typography } from "@mui/material";

const FormFieldContainer = ({
    gap = 2, // space between heading, subheading, and fields
    heading,
    headingSx = {},
    subHeading,
    subHeadingSx = {},
    required = false,
    errorMessage,
    fields,
}) => {
    return (
        <Stack sx={{ textAlign: "left" }} gap={gap} width={"100%"}>
            {/* Heading */}
            {heading && (
                <Typography
                    sx={{
                        fontWeight: 700,
                        color: "#1e293b",
                        fontSize: "1rem",
                        ...headingSx,
                    }}
                >
                    {heading} {required && <span style={{ color: "#ef4444" }}>*</span>}
                </Typography>
            )}

            {/* Sub-heading/Instructional Text */}
            {subHeading && (
                <Typography
                    sx={{
                        color: "#475569",
                        fontSize: "0.95rem",
                        lineHeight: 1.5,
                        ...subHeadingSx,
                    }}
                >
                    {subHeading}
                </Typography>
            )}

            {/* Render passed form fields */}
            <Box>
                <Grid container spacing={2}>
                    {fields?.map((field, id) => {
                        return (
                            <Grid item xs={fields.length > 1 ? 6 : 12} key={id}>
                                {field}
                            </Grid>
                        );
                    })}
                </Grid>
                {errorMessage && (
                    <FormHelperText sx={{ color: "#ef4444", ml: 0, mt: 1 }}>
                        {errorMessage}
                    </FormHelperText>
                )}
            </Box>
        </Stack>
    );
};

export default FormFieldContainer;

export const FormContainer = ({ children, sx, heading, subHeading }) => {
    return (
        <Stack
            sx={{
                mt: 5,
                gap: 3,
                width: "100%",
                textAlign: "left",
                ...sx,
            }}
        >
            {heading && (
                <Typography variant="h3" sx={{ color: "#0f172a" }}>
                    {heading}
                </Typography>
            )}
            {subHeading && (
                <Typography variant="body1" sx={{ color: "#475569" }}>
                    {subHeading}
                </Typography>
            )}

            {children}
        </Stack>
    );
};

export const inputStyles = (error) => ({
    "& .MuiOutlinedInput-root, .MuiOutlinedInput-root:active": {
        backgroundColor: "#fff",
        height: "40px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: error ? "#ef4444" : "#cbd5e1",
    },
});

export const autoCompleteStyles = (error) => ({
    "& .MuiOutlinedInput-root, .MuiOutlinedInput-root:active": {
        backgroundColor: "#fff",
        height: "40px",
        "& .MuiAutocomplete-input": {
            padding: "1px 4px 7.5px 6px",
        },
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: error ? "#ef4444" : "#cbd5e1",
    },
});
